// removed by extract-text-webpack-plugin
module.exports = {"demoBarHeader":"demoBarHeader__1i7f7XQyvdU4","demoBarLink":"demoBarLink__HMmkxSbwPdbr","demoBarLinkInline":"demoBarLinkInline__mmI9TgrnbVUi"};